
import { defineComponent, ref, watch } from "vue";
import { specList, calculateSpec } from "@/api/Commodityallocation";
// import type { UploadProps, UploadUserFile } from "element-plus";
import { ElMessage } from "element-plus";
import { useRoute } from "vue-router";
import { Plus } from "@element-plus/icons-vue";
import { UploadUrl } from "@/utils/request";
export default defineComponent({
  name: "SpeciFications",
  // components: { Plus },
  emits: ["update:submitTableData"],
  props: {
    productSpecVo: Array as any,
    submitTableData: Object as any,
    apiShopSpecProducts: Object as any,
  },
  setup(props, { emit }) {
    // 规格数据
    const route = useRoute();
    const specArr = ref<Res.specList[]>();
    const getSpecList = () => {
      specList().then((res) => {
        specArr.value = res.data;
        specArr.value.forEach((item: any) => {
          item.list.forEach((item2: any) => {
            item2.isCheck = false;
            item2.spectname = item.name;
            if (route.query.code) {
              props.apiShopSpecProducts.forEach((item3: any, index3: number) => {
                if (item3.specItemName == item2.name) {
                  item2.select2 = true;
                }
              });
            }
          });
        });
        specArr.value.map((item: any, index: any) => {
          props.apiShopSpecProducts.map((item2: any, index2: any) => {
            if (item.id == item2.specId) {
              console.log(2);
              item.list.push({
                id: item.list.length + 1,
                isCheck: false,
                name: item2.specItemName,
                select: false,
                specId: item2.specId,
                select2: true,
              });
            }
          });
        });
        for (let i = 0; i < specArr.value.length; i++) {
          for (let j = 0; j < specArr.value[i].list.length; j++) {
            for (let k = j + 1; k < specArr.value[i].list.length; k++) {
              if (specArr.value[i].list[j].name == specArr.value[i].list[k].name) {
                specArr.value[i].list.splice(k, 1);
                --k;
              }
            }
          }
        }
        console.log(props.apiShopSpecProducts, ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        console.log(specArr.value, "<<<<<<<<<<<<<<<<<<<<<<<<<----------------");
      });
    };

    getSpecList();
    // 表格数据
    const tableData = ref();
    const tableColumn = ref<{ prop?: string; label?: string; slotName?: string }[]>([
      // {
      //   prop: "date",
      //   label: "颜色",
      // },
      // {
      //   prop: "date",
      //   label: "容量",
      // },
      // {
      //   prop: "date",
      //   label: "材质",
      // },
      // {
      //   prop: "date",
      //   label: "规格",
      // },
      // {
      //   prop: "date",
      //   label: "版本",
      // },
      {
        slotName: "price",
      },
      {
        slotName: "officialPrice",
      },
      {
        slotName: "uploadimg",
      },

      {
        slotName: "slotName",
      },
    ]);
    const ifFlage = ref(false);
    const pageSize = ref(5);
    const mytotal = ref(0);
    const currentPage = ref(1);
    const handleCurrentChange = (val: any) => {
      currentPage.value = val;
    };
    // 后端表格表头数据
    const tableHeadData = ref<any>();
    watch(
      () => props.productSpecVo,
      () => {
        tableHeadData.value = props.productSpecVo;
        // tableHeadData.value.
        // myObject.value.productSpecs
        // console.log(tableHeadData.value, "{{{{{{{{{{{{{{{{{{");

        // tableHeadData.value.productSpecItemVoList.forEach((item: any, index: number) => {
        //   arrConcat(myObject.value.productSpecs, item);
        // });
        let arr = tableHeadData.value.titleList;
        let _colorIndex = arr.indexOf("颜色");
        let _skuIndex = arr.indexOf("版本");
        let _ramIndex = arr.indexOf("内存");
        let _tranIndex = arr.indexOf("容量");
        let _textureIndex = arr.indexOf("材质");
        let _sizeIndex = arr.indexOf("规格");
        tableData.value = [];
        tableData.value = tableHeadData.value.productSpecItemVoList.map(
          (e: { sku: string; price: number; index: number; productId: number; officialPrice: number; specItemList: string; img: string }) => {
            return {
              sku: e.sku,
              price: e.price,
              productId: e.productId,
              isDelete: !!e.productId,
              officialPrice: e.officialPrice,
              index: e.index,
              颜色: e.specItemList[_colorIndex] || "",
              版本: e.specItemList[_skuIndex] || "",
              内存: e.specItemList[_ramIndex] || "",
              容量: e.specItemList[_tranIndex] || "",
              材质: e.specItemList[_textureIndex] || "",
              规格: e.specItemList[_sizeIndex] || "",
              productImg: e.img || "",
              // isDelect: true,
            };
          }
        );
        // console.log(tableData.value, "999999*************************");

        // specArr.value?.forEach(item);
        // 合并规格
        // const specItem = ref<{ name: string; spectname: string; specId: number }[]>([]);
        var integration = ref<string[]>([]);
        var integration2 = ref<string[]>([]);
        var integration3 = ref<string[]>([]);
        var integration4 = ref<string[]>([]);
        var integration5 = ref<string[]>([]);
        var integration6 = ref<string[]>([]);
        tableData.value.forEach((item: any, index: number) => {
          if (item.颜色) {
            integration.value.push(item.颜色);
          }
          if (item.内存) {
            integration2.value.push(item.内存);
          }
          if (item.容量) {
            integration3.value.push(item.容量);
          }
          if (item.材质) {
            integration4.value.push(item.材质);
          }
          if (item.规格) {
            integration5.value.push(item.规格);
          }
          if (item.版本) {
            integration6.value.push(item.版本);
          }
          for (let i = 0; i < integration.value.length; i++) {
            for (let j = i + 1; j < integration.value.length; j++) {
              if (integration.value[i] == integration.value[j]) {
                // arr[i].specItem = arr[j].specItem;
                integration.value.splice(j, 1);
              }
            }
          }
          for (let i = 0; i < integration2.value.length; i++) {
            for (let j = i + 1; j < integration2.value.length; j++) {
              if (integration2.value[i] == integration2.value[j]) {
                // arr[i].specItem = arr[j].specItem;
                integration2.value.splice(j, 1);
              }
            }
          }
          for (let i = 0; i < integration3.value.length; i++) {
            for (let j = i + 1; j < integration3.value.length; j++) {
              if (integration3.value[i] == integration3.value[j]) {
                // arr[i].specItem = arr[j].specItem;
                integration3.value.splice(j, 1);
              }
            }
          }
          for (let i = 0; i < integration4.value.length; i++) {
            for (let j = i + 1; j < integration4.value.length; j++) {
              if (integration4.value[i] == integration4.value[j]) {
                // arr[i].specItem = arr[j].specItem;
                integration4.value.splice(j, 1);
              }
            }
          }
          for (let i = 0; i < integration5.value.length; i++) {
            for (let j = i + 1; j < integration5.value.length; j++) {
              if (integration5.value[i] == integration5.value[j]) {
                // arr[i].specItem = arr[j].specItem;
                integration5.value.splice(j, 1);
              }
            }
          }
          for (let i = 0; i < integration6.value.length; i++) {
            for (let j = i + 1; j < integration6.value.length; j++) {
              if (integration6.value[i] == integration6.value[j]) {
                // arr[i].specItem = arr[j].specItem;
                integration6.value.splice(j, 1);
              }
            }
          }
          for (let key in item) {
            if (key == "颜色") {
              myObject.value.productSpecs.push({ specId: 1, name: key, specItem: integration.value });
            } else if (key == "内存") {
              myObject.value.productSpecs.push({ specId: 2, name: key, specItem: integration2.value });
            } else if (key == "容量") {
              myObject.value.productSpecs.push({ specId: 3, name: key, specItem: integration3.value });
            } else if (key == "材质") {
              myObject.value.productSpecs.push({ specId: 4, name: key, specItem: integration4.value });
            } else if (key == "规格") {
              myObject.value.productSpecs.push({ specId: 5, name: key, specItem: integration5.value });
            } else if (key == "版本") {
              myObject.value.productSpecs.push({ specId: 6, name: key, specItem: integration6.value });
            }
          }
        });
        for (let i = 0; i < myObject.value.productSpecs.length; i++) {
          for (let j = i + 1; j < myObject.value.productSpecs.length; j++) {
            if (myObject.value.productSpecs[i].specId == myObject.value.productSpecs[j].specId) {
              // arr[i].specItem = arr[j].specItem;
              myObject.value.productSpecs.splice(j, 1);
              --j;
            }
          }
        }
        for (let i = 0; i < myObject.value.productSpecs.length; i++) {
          if (myObject.value.productSpecs[i].specItem.length == 0) {
            myObject.value.productSpecs.splice(i, 1);
            --i;
          }
        }
        // console.log(tableData.value, "888888888888888888888888888");
        mytotal.value = tableData.value.length;
        tableData.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value);
        ifFlage.value = true;
        getTable();
      }
    );

    // 渲染表格参数
    const myObject = ref<any>({
      productCode: route.query.code || "",
      productSpecs: [],
    });
    // 点击规格渲染列表接口
    const getcalculateSpec = () => {
      calculateSpec(myObject.value).then((res) => {
        if (res.code == 1) {
          if (tableData.value?.productSpecs) {
            tableData.value.productSpecs = [];
          }
          tableHeadData.value = res.data;
          getTable();
        }
      });
    };
    // 点击规格
    const myInputCheckbox = (row: any) => {
      // console.log(row, "000000000000000000000000000000");

      if (!row.isCheck) {
        row.select = true;
        row.isCheck = true;
        arrConcat(myObject.value.productSpecs, row);
        getcalculateSpec();
      } else {
        // console.log("删除" + row.name);
        row.select = false;
        row.isCheck = false;
        arrConcat(myObject.value.productSpecs, row, true);
        qxcheck(myObject.value.productSpecs, row);
        getcalculateSpec();
        if (!myObject.value.productSpecs.length) {
          // console.log("清空");
          tableData.value = [];
          myObject.value.productSpecs = [];
        }
      }
      // console.log(myObject.value.productSpecs, "...................................");
    };
    // 规格输入修改名字

    //  input失焦操作
    const focusInput = (name: string, row: { name: string; spectname: string; specId: number; isCheck: boolean; select: boolean }) => {
      if (name !== "") {
        row.name = name;
        arrConcat(myObject.value.productSpecs, row);
        getcalculateSpec();
        // row.select = false;
      } else {
        Disabledisplay.value = true;
        dialogTitle.value = "规格属性不能输入为空！";
        row.name = saveInputVal.value;
        getcalculateSpec();
      }
    };
    // 保存聚焦值防止空input
    const saveInputVal = ref<string>("");
    const saveVal = (val: any) => {
      saveInputVal.value = val.target.value;
    };
    const clearTable = () => {
      tableColumn.value = [
        {
          slotName: "price",
        },
        {
          slotName: "officialPrice",
        },
        {
          slotName: "uploadimg",
        },

        {
          slotName: "slotName",
        },
      ];
    };

    const Disabledisplay = ref<boolean>(false);
    const dialogTitle = ref<string>("");
    // 合并规格
    const oldArr = ref<any>([]);
    const specItem = ref<any>([]);
    const isCheck = ref<boolean>(true);
    const arrConcat = (
      arr: [{ name: string; specItem: string[]; specId: number }],
      row: { name: string; spectname: string; specId: number; isCheck: boolean },
      isDelete?: boolean
    ) => {
      if (isDelete) {
        specItem.value.forEach((item: any, index: number) => {
          if (item.name == row.name) {
            specItem.value.splice(index, 1);
          }
        });
        return;
      }

      var integration = ref<string[]>([]);
      specItem.value.push(row);
      for (let i = 0; i < specItem.value.length; i++) {
        for (let j = i + 1; j < specItem.value.length; j++) {
          if (specItem.value[i].name === specItem.value[j].name && specItem.value[i].specId == specItem.value[j].specId) {
            specItem.value.splice(j, 1);
            --j;
          }
        }
      }

      // 只管编辑 start----------
      if (!oldArr.value.length && route.query.code) {
        oldArr.value = JSON.parse(JSON.stringify(arr));
        oldArr.value.forEach((item: any) => {
          item.specItem.forEach((e: any) => {
            specItem.value.push({ specId: item.specId, name: e });
          });
        });
      }
      // 只管编辑 end-----------------------
      specItem.value.forEach((item: any) => {
        if (item.specId == row.specId) {
          integration.value.push(item.name);
        }
      });
      console.log(specItem.value, "---------------");
      console.log(arr);

      // isCheck.value = true;
      arr.push({ name: row.spectname, specId: row.specId, specItem: integration.value });
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].name == arr[j].name) {
            // arr[i].specItem = arr[j].specItem;
            arr.splice(i, 1);
            --j;
          }
        }
      }
      // console.log(arr, "+++++++++++++++++++++++++++++++++++++++");
    };
    // 取消选中规格删除
    const qxcheck = (arr: [{ name: string; specItem: string[] }], row: { name: string; spectname: string }) => {
      // 取消勾选删除数据
      arr.forEach((item, index) => {
        if (row.spectname == item.name) {
          item.specItem.forEach((item2, index2) => {
            if (item2 == row.name) {
              item.specItem.splice(index2, 1);
            }
            if (!item.specItem.length) {
              arr.splice(index, 1);
            }
          });
        }
      });
      // console.log(arr, "取消点击");
    };

    const getTable = () => {
      let obj = {};
      clearTable();
      // console.log(tableHeadData.value, "有数据了---------------------------------------------------");

      tableHeadData.value.titleList.map((item: string) => {
        tableColumn.value.unshift({ label: item, prop: item });
        obj = { [item]: "", ...obj };
      });
      let arr = tableHeadData.value.titleList;
      let _colorIndex = arr.indexOf("颜色");
      let _skuIndex = arr.indexOf("版本");
      let _ramIndex = arr.indexOf("内存");
      let _tranIndex = arr.indexOf("容量");
      let _textureIndex = arr.indexOf("材质");
      let _sizeIndex = arr.indexOf("规格");
      tableData.value = [];
      tableData.value = tableHeadData.value.productSpecItemVoList.map(
        (e: { sku: string; price: number; index: number; productId: number; officialPrice: number; specItemList: string; img: string }) => {
          return {
            sku: e.sku,
            price: e.price,
            isDelete: !!e.productId,
            productId: e.productId,
            officialPrice: e.officialPrice,
            index: e.index,
            颜色: e.specItemList[_colorIndex] || "",
            版本: e.specItemList[_skuIndex] || "",
            内存: e.specItemList[_ramIndex] || "",
            容量: e.specItemList[_tranIndex] || "",
            材质: e.specItemList[_textureIndex] || "",
            规格: e.specItemList[_sizeIndex] || "",
            productImg: e.img || "",
          };
        }
      );
      console.log("表格数据");
      console.log(tableData.value);
      console.log("表格头部");
      console.log(tableColumn.value);
      mytotal.value = tableData.value.length;
      tableData.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value);
      ifFlage.value = true;
      emit("update:submitTableData", tableData.value);
      // console.log(obj);
    };

    // 回显
    // if (props.productSpecVo.titleList.length) {
    //   // tableHeadData.value = props.productSpecVo;
    //   // props.productSpecVo.productSpecItemVoList.forEach((item: any) => {
    //   //   specItem.value.push({id:null,isCheck:true,name:item.});
    //   // });
    // }
    // 删除操作
    const edit = (row: any, index: number) => {
      // console.log(row);
      console.log(tableData.value);

      tableData.value.forEach((item: any, isindex: number) => {
        if (item.sku == row.sku) {
          tableData.value.splice(isindex, 1);
          mytotal.value = tableData.value.length;
          tableData.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value);
        }
      });
      // console.log(tableData.value);
    };
    const upLoadindex = ref();
    // 图片上传
    const handleAvatarSuccess = (response: any) => {
      // console.log(response);

      tableData.value.forEach((item: any, index: any) => {
        if (item.index == upLoadindex.value) {
          item.productImg = response.fileUrl;
          // response.fileUrl
        }
      });
      // console.log(tableData.value, "********************");

      // MyImage.value = response.fileUrl;
    };
    const uploadImg = (row: any) => {
      // console.log(row);

      upLoadindex.value = row.index;
    };
    const removeImage = (row: any) => {
      // console.log(row);
      tableData.value.forEach((item: any, index: any) => {
        if (item.index == row.index) {
          item.productImg = "";
          // response.fileUrl
        }
      });
    };
    // 预览图片
    const fileList = ref<string[]>([]);
    const imgViewerVisible = ref(false);
    const handlePictureCardPreview = (row: any) => {
      // console.log(row);
      fileList.value = [];
      fileList.value.push(row.productImg);
      imgViewerVisible.value = true;
    };
    const maychange = (val: any) => {
      console.log(val);
    };
    return {
      specArr,
      myInputCheckbox,
      focusInput,
      isCheck,
      Disabledisplay,
      dialogTitle,
      tableData,
      tableColumn,
      saveVal,
      edit,
      handleAvatarSuccess,
      Plus,
      uploadImg,
      removeImage,
      imgViewerVisible,
      handlePictureCardPreview,
      fileList,
      UploadUrl,
      currentPage,
      handleCurrentChange,
      ifFlage,
      pageSize,
      mytotal,
      maychange,
    };
  },
});
